<template>
	<div>
		<div style="margin: 20px 10px;">
			<van-button  @click="logout" type="default" plain block>注销</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			logout () {
				// localStorage.setItem('openId', '')
				// localStorage.setItem('unionId', '')
				localStorage.setItem('token', '')
				localStorage.setItem('operator', '')
				if (typeof plus != "undefined") {
					uni.reLaunch({
						url: '../main/main'
					})
				} else {
					this.$router.push('login')
				}
			}
		},
		created () {
			this.$route.meta.isBack = false
		}
	}
</script>

<style>
</style>
